import { DomainFactorModel } from '../../models/domain-factor.model';
import { DomainFactorsApi } from '../../apis/domain-factors.api';
import { BaseListStore } from '@monorepo/controlled/src/stores/base-list.store';
import { IAskError } from '@monorepo/tools/src/lib/tools/ask/ask';
import { DomainFactorCrudStore } from './domain-factor-crud.store';

export enum DomainFactorsStoreKeys {
	DomainFactors = 'domain-factors',
}

export class DomainFactorsStore {
	private isLoading = false;
	private error: Error | null = null;
	// private domainFactors: DomainFactorModel[] = [];
	private crud = new DomainFactorCrudStore();
	listStore = new BaseListStore<DomainFactorModel>({
		listFunc: DomainFactorsApi.list,
		model: DomainFactorModel,
	});

	getCrud() {
		return this.crud;
	}

	getDomainFactors(): DomainFactorModel[] {
		return this.listStore.getList();
	}
	getIsLoading(): boolean {
		return this.isLoading;
	}
	getError(): Error | null {
		return this.error;
	}

	async fetchAll() {
		this.listStore.setIsLocalCache(false);
		await this.listStore.fetch();
	}

	async fetchByCampaign(campaignId: string) {
		this.listStore.setIsLoading(true);
		try {
			const res = await DomainFactorsApi.getByCampaign(campaignId);
			const rows = (Array.isArray(res) ? res : []).map(item => new DomainFactorModel(item));
			this.listStore.setList(rows);
			this.listStore.setError(null);
		} catch (error) {
			this.listStore.setError(error as IAskError);
		} finally {
			this.listStore.setIsLoading(false);
		}
	}

	async fetchByDomain(domain: string) {
		this.listStore.setIsLoading(true);
		try {
			const res = await DomainFactorsApi.getByDomain(domain);
			const rows = (Array.isArray(res) ? res : []).map(item => new DomainFactorModel(item));
			this.listStore.setList(rows);
			this.listStore.setError(null);
		} catch (error) {
			this.listStore.setError(error as IAskError);
		} finally {
			this.listStore.setIsLoading(false);
		}
	}
}
